import { useState } from 'react';

interface Props {
  consentText: string;
  signerName: string;
  onAccept: () => void;
  onDecline: () => void;
}

export default function ESignConsentModal({ consentText, signerName, onAccept, onDecline }: Props) {
  const [scrolledToBottom, setScrolledToBottom] = useState(false);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    const atBottom = target.scrollHeight - target.scrollTop - target.clientHeight < 20;
    if (atBottom) setScrolledToBottom(true);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full max-h-[90vh] flex flex-col">
        <div className="p-6 border-b">
          <h2 className="text-lg font-semibold text-gray-900">Electronic Signature Consent</h2>
          <p className="text-sm text-gray-500 mt-1">
            Please review the disclosure below before proceeding.
          </p>
        </div>

        <div
          className="flex-1 overflow-y-auto p-6 text-sm text-gray-700 leading-relaxed whitespace-pre-wrap"
          onScroll={handleScroll}
        >
          {consentText}
        </div>

        <div className="p-6 border-t bg-gray-50">
          <p className="text-xs text-gray-500 mb-4">
            By clicking "I Agree", I, <span className="font-medium">{signerName}</span>, consent to the use of electronic signatures and records for this transaction.
          </p>
          <div className="flex gap-3">
            <button
              onClick={onDecline}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
            >
              Decline
            </button>
            <button
              onClick={onAccept}
              disabled={!scrolledToBottom}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-gray-900 rounded hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {scrolledToBottom ? 'I Agree' : 'Please scroll to read'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
